import { createSelector } from 'reselect';

import * as loadingState from '@blueberry/constants/loadingState';

export const types = {
  FETCH_CAMPAIGN: 'FETCH_CAMPAIGN',
  FETCH_CAMPAIGN_SUCCSESS: 'FETCH_CAMPAIGN_SUCCESS',
  FETCH_CAMPAIGN_FAILURE: 'FETCH_CAMPAIGN_FAILURE',
  GO_NEXT_QUIZ: 'GO_NEXT_QUIZ',
  SAVE_ANSWER: 'SAVE_ANSWER',
  FETCH_CAMPAIGN_RESULT: 'FETCH_CAMPAIGN_RESULT',
  FETCH_CAMPAIGN_RESULT_SUCCSESS: 'FETCH_CAMPAIGN_RESULT_SUCCSESS',
  FETCH_CAMPAIGN_RESULT_FAILURE: 'FETCH_CAMPAIGN_RESULT_FAILURE',
  SAVE_RESULT: 'SAVE_RESULT',
  SAVE_CAMPAIGN_RESULT: 'SAVE_CAMPAIGN_RESULT',
};

export const fetchCampaign = id => ({
  type: types.FETCH_CAMPAIGN,
  payload: {
    id,
  },
});

export const fetchCampaignSuccess = (campaign, quizzes) => ({
  type: types.FETCH_CAMPAIGN_SUCCSESS,
  payload: {
    campaign,
    quizzes,
  },
});

export const fetchCampaignFailure = () => ({
  type: types.FETCH_CAMPAIGN_FAILURE,
});

export const goNextQuiz = () => ({
  type: types.GO_NEXT_QUIZ,
});

export const saveAnswer = answer => ({
  type: types.SAVE_ANSWER,
  payload: {
    answer,
  },
});

export const fetchCampaignResult = id => ({
  type: types.FETCH_CAMPAIGN_RESULT,
  payload: {
    id,
  },
});

export const fetchCampaignResultSuccess = score => ({
  type: types.FETCH_CAMPAIGN_RESULT_SUCCSESS,
  payload: {
    score,
  },
});

export const fetchCampaignResultFailure = () => ({
  type: types.FETCH_CAMPAIGN_RESULT_FAILURE,
});

export const saveResult = () => ({
  type: types.SAVE_RESULT,
});

export const saveCampaignResult = () => ({
  type: types.SAVE_CAMPAIGN_RESULT,
});

const initialState = {
  state: loadingState.EMPTY,
  campaign: {},
  quizzes: [],
  currentIndex: -1,
  score: 0,
  answers: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CAMPAIGN:
      return {
        ...state,
        ...initialState,
        state: loadingState.LOADING,
      };
    case types.FETCH_CAMPAIGN_SUCCSESS:
      return {
        ...state,
        state: loadingState.READY,
        campaign: action.payload.campaign,
        quizzes: action.payload.quizzes,
      };
    case types.FETCH_CAMPAIGN_FAILURE:
      return {
        ...state,
        state: loadingState.ERROR,
      };
    case types.GO_NEXT_QUIZ:
      return {
        ...state,
        currentIndex: state.currentIndex + 1,
      };
    case types.SAVE_ANSWER: {
      const answers = state.answers;
      answers[state.currentIndex] = action.payload.answer;

      return {
        ...state,
        answers,
      };
    }
    case types.FETCH_CAMPAIGN_RESULT_SUCCSESS:
      return {
        ...state,
        score: action.payload.score,
      };
    case types.FETCH_CAMPAIGN_RESULT_FAILURE:
      return {
        ...state,
        state: loadingState.ERROR,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;

export const getCampaign = state => state.campaign.campaign;
export const getQuizzes = state => state.campaign.quizzes;
export const getQuizIndex = state => state.campaign.currentIndex;
export const getCurrentQuiz = createSelector(
  getQuizzes,
  getQuizIndex,
  (quizzes, index) => quizzes[index]
);
export const getState = state => state.campaign.state;
export const getAnswers = state => state.campaign.answers;
export const getScore = state => state.campaign.score;



// WEBPACK FOOTER //
// ./app/redux/campaign.js